import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import EditGrid from '../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {styleForHeader} from '../../style.js';

class ProcessGroup extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : [
          { field: 'id', hide: true},
          { field: 'name', width: 200, headerAlign: 'center', align:'center', text:'SÜREÇ GRUP ADI',
            renderHeader: () => styleForHeader('SÜREÇ GRUP ADI')
          }
        ],
        CRUDServices:{
          Create:apiDashBoardService.createProcessGroup,
          Update:apiDashBoardService.updateProcessGroup,
          Delete:apiDashBoardService.deleteProcessGroupById}
      };
    }
    refreshList(){
      apiDashBoardService.getProcessGroups()
      .then((response) => {
        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Süreç grubu bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getProcessGroups exception: ' + JSON.stringify(exception));
      });      
    }
    componentDidMount() {
      this.refreshList();
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <BasicPageComponent
              title='SÜREÇ GRUPLARI'
              description='Süreç Grubu Tanımlama Ekranı'
              children = {
                <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Süreç Grupları" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
              </ScreenContainer>
              }
            />       
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(ProcessGroup);